export default "__VITE_ASSET__533b725c__"